module.exports = __webpack_public_path__ + "static/markai-8c15e7d3413978dfffb5581152816ecc.jpg";